<router-outlet (activate)="onActivate()" />

<ng-http-loader
  opacity="0.9"
  [backdrop]="true"
  [backgroundColor]="'#000592'"
  [spinner]="spinkit.skWave"
  [filteredHeaders]="[globalLoaderDisabledHeader]"
  [filteredUrlPatterns]="[
    'maps',
    'rolodex/search',
    'avatar',
    'resource',
    'google',
    'negotiate',
    'signalr',
    'maps',
    'user',
    'lookup',
    'files'
  ]" />
